import type { RudderAnalytics } from '@rudderstack/analytics-js/bundled';

/*
  RudderStack's v3 SDK, the one todesktop.com and ToDesktop Builder use. All
  of them keep their IDs in cookies on .todesktop.com, which v3 encrypts as
  `RS_ENC_v3_…`; the v1 SDK the dashboard loaded before couldn't read those.
  v3 still reads cookies the v1 SDK wrote (`RudderEncrypt:…`), so returning
  visitors keep their IDs.

  The bundled build carries its plugins instead of fetching them from
  RudderStack's CDN, and requests go through our proxy, so ad blockers
  don't drop events.
*/

const PROXY_URL = 'https://rsp.todesktop.workers.dev';

const writeKey =
  process.env.VITE_PROJECT_ID === 'todesktop-prod1'
    ? '2FGj3d2MAEBmSQH1wSJA14xrkOJ'
    : '2FGjIpNdOlA0Tp85WMXLvyf7puP';

let client: Promise<RudderAnalytics> | undefined;

/**
 * Loads the SDK once (in its own chunk) and records the page view. A failed
 * load isn't kept, so the next call tries again: RudderStack also loads
 * Intercom, which would otherwise stay missing for the rest of the tab.
 */
export const loadRudderAnalytics = () =>
  (client ??= import('@rudderstack/analytics-js/bundled')
    .then(({ RudderAnalytics }) => {
      const analytics = new RudderAnalytics();
      analytics.load(writeKey, PROXY_URL, { configUrl: PROXY_URL });
      analytics.page();
      return analytics;
    })
    .catch((error: unknown) => {
      client = undefined;
      throw error;
    }));
